document.addEventListener('DOMContentLoaded', function () {
  let vimeoApiPromise = null;

  // Load the Vimeo player API only when a popup is first opened
  function loadVimeoApi() {
    if (window.Vimeo && window.Vimeo.Player) return Promise.resolve();
    if (vimeoApiPromise) return vimeoApiPromise;
    vimeoApiPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://player.vimeo.com/api/player.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return vimeoApiPromise;
  }

  document.querySelectorAll('[id^="cp-custom-card-trigger-"]').forEach((trigger) => {
    const blockId = trigger.id.replace('cp-custom-card-trigger-', '');
    const overlay = document.getElementById(`cp-custom-popup-overlay-${blockId}`);
    const closeButton = document.getElementById(`cp-custom-close-popup-${blockId}`);
    if (!trigger || !overlay || !closeButton) return;

    const iframe = overlay.querySelector('iframe');
    let player = null;

    function initPlayer() {
      if (!iframe) return Promise.resolve();

      // Deferred src: only assign when the popup is opened
      if (!iframe.src && iframe.dataset.vimeoSrc) {
        iframe.src = iframe.dataset.vimeoSrc;
      }
      if (!iframe.title) {
        iframe.title = 'Vimeo player';
      }

      return loadVimeoApi().then(() => {
        if (!player) {
          player = new Vimeo.Player(iframe);
        }
      });
    }

    trigger.addEventListener('click', () => {
      overlay.style.display = 'block';
      overlay.style.opacity = '1';
      initPlayer().then(() => {
        if (player) player.play();
      }).catch(() => {});
    });

    function closePopup() {
      overlay.style.display = 'none';
      overlay.style.opacity = '0';
      if (player) player.pause();
    }

    closeButton.addEventListener('click', closePopup);

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closePopup();
    });
  });
});
